var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.302 4.27495C16.245 4.19895 13.186 1.15895 13.186 1.15895C13.129 1.10195 12.958 0.949951 12.711 0.949951H5.68101C5.32001 0.949951 5.01601 1.25395 5.01601 1.61495V3.47695H3.15401C2.79301 3.47695 2.48901 3.78095 2.48901 4.14195V17.4039C2.48901 17.7649 2.79301 18.069 3.15401 18.069H13.319C13.68 18.069 13.984 17.7649 13.984 17.4039V15.542H15.846C16.207 15.542 16.511 15.238 16.511 14.877C16.511 14.877 16.511 4.78795 16.511 4.76895C16.511 4.63595 16.435 4.40795 16.302 4.27495ZM3.81901 16.72V4.80695H9.53801V7.27695C9.53801 7.63795 9.82301 7.94195 10.203 7.94195H12.654V16.72H3.81901ZM13.984 14.212V7.27695C13.984 7.12495 13.908 6.93495 13.794 6.80195L10.659 3.66695C10.583 3.57195 10.412 3.47695 10.203 3.47695H6.34601V2.27995H12.046V4.74995C12.046 5.11095 12.35 5.41495 12.711 5.41495H15.181V14.193H13.984V14.212Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.73fcd8f4e957ff4e29b2dc6fe1ace829.svg";
export { ForwardRef as ReactComponent };